module.exports = __webpack_public_path__ + "static/media/singapore.54ace374.svg";